function processHighlights(content, highlights, parentRange) {
  let sortedHighlights = [...highlights].sort((a, b) => {
    // sort by start range
    if (a.range[0] !== b.range[0]) {
      return a.range[0] - b.range[0];
    }

    // if start the same, sort by end range in reverse order
    return b.range[1] - a.range[1];
  });

  const result = [];
  let lastEnd = parentRange[0];

  for (let index = 0; index < sortedHighlights.length; index++) {
    const highlight = sortedHighlights[index];
    const { highlightIndex, range } = highlight;

    if (highlightIndex === undefined || range === undefined) {
      console.error(
        "highlightIndex and range is required in highlight:",
        highlight
      );
      continue;
    }

    const [start, end] = highlight.range;

    // add text before current highlight's start range if needed
    if (start > lastEnd) {
      result.push({
        range: [lastEnd, start],
        text: content.slice(lastEnd, start),
        children: [],
      });
    }

    // get children for current highlight
    const children = sortedHighlights.filter(
      (h) => h !== highlight && h.range[0] >= start && h.range[0] < end
    );

    // delete current highlight and children from sortedHighlights (because they are processed in this iteration)
    sortedHighlights = sortedHighlights.filter(
      (h) => h === highlight || !(h.range[0] >= start && h.range[0] < end)
    );

    const hasChildren = children.length > 0;
    // current highlight
    const node = {
      ...highlight,
      text: hasChildren ? "" : content.slice(start, end),
      children: hasChildren
        ? processHighlights(content, children, highlight.range)
        : [],
    };

    result.push(node);

    lastEnd = Math.max(
      end,
      Math.max(...children.map((child) => child.range[1]))
    );
  }

  // Add the last part if needed
  const parentEnd = parentRange[1];

  if (lastEnd <= parentEnd) {
    result.push({
      range: [lastEnd, parentEnd],
      text: content.slice(lastEnd, parentEnd),
      children: [],
    });
  }

  return result;
}

export default processHighlights;
